import type { GetStaticProps } from 'next'
import type { ComponentProps } from 'react'

import { getFreeGuidesLandingPage } from '@/graphql/FreeGuidesLandingPage'

import { FreeGuideLandingPage } from '@/components/pages/freeguide/FreeGuideLandingPage'

type Props = ComponentProps<typeof FreeGuideLandingPage>

export default FreeGuideLandingPage

export const getStaticProps: GetStaticProps<Props> = async () => {
  const page = await getFreeGuidesLandingPage()
  if (page) {
    return { props: { page: page } }
  }

  return {
    notFound: true,
  }
}
